var map = {
	"./auth/auth.module": [
		"./src/app/auth/auth.module.ts",
		"auth.module"
	],
	"./components/clients/clients.module": [
		"./src/app/components/clients/clients.module.ts"
	],
	"./components/detail/detail.module": [
		"./src/app/components/detail/detail.module.ts"
	],
	"./components/forms/forms.module": [
		"./src/app/components/forms/forms.module.ts"
	],
	"./components/profile/profile.module": [
		"./src/app/components/profile/profile.module.ts"
	],
	"./components/users/users.module": [
		"./src/app/components/users/users.module.ts"
	],
	"./dashboard/dashboard.module": [
		"./src/app/dashboard/dashboard.module.ts",
		"dashboard.module"
	],
	"./forgot-password/forgot-password.module": [
		"./src/app/auth/forgot-password/forgot-password.module.ts",
		"forgot-password.module"
	],
	"./login/basic-login/basic-login.module": [
		"./src/app/auth/login/basic-login/basic-login.module.ts",
		"basic-login.module"
	],
	"./registration/basic-reg/basic-reg.module": [
		"./src/app/auth/registration/basic-reg/basic-reg.module.ts",
		"basic-reg.module"
	],
	"./reset-password/reset-password.module": [
		"./src/app/auth/reset-password/reset-password.module.ts",
		"reset-password.module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src/$$_lazy_route_resource lazy
// module id = ./src/$$_lazy_route_resource lazy recursive
// module chunks = main